import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Small floating "Back to top" control that appears once the customer has
// scrolled down a meaningful amount. On mobile it sits above the bottom nav.
export function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      data-testid="back-to-top-button"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-20 right-5 z-50 flex min-h-11 w-11 items-center justify-center rounded-full pe-surface text-[#164C3B] shadow-[0_6px_20px_-6px_rgba(23,23,23,0.25)] transition-colors hover:bg-[#DDE7DF] md:bottom-6"
    >
      <ArrowUp className="h-5 w-5" strokeWidth={2.2} />
    </button>
  );
}
